// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const FISC_TP_INCENTIVO = {
  Nenhum: 'FISC_TP_INCENTIVO1',
  ReducaoBase: 'FISC_TP_INCENTIVO2',
  CreditoPresumido: 'FISC_TP_INCENTIVO3',
  Isencaodeferimento: 'FISC_TP_INCENTIVO4',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    FISC_TP_INCENTIVO1: 1,
    FISC_TP_INCENTIVO2: 2,
    FISC_TP_INCENTIVO3: 3,
    FISC_TP_INCENTIVO4: 4
  }
}
